import env from 'config/env';
import api, { proxyAPI } from '../httpClient';

// This token identifies the app (not the user)
const APP_TOKEN =
  env === 'production'
    ? 'bWFrc3ltLnNoZXZlcmRhQGd1ZXN0eS5jb206YWJjMTIz'
    : 'cUFxdVBjcHV3ZGhXYkpzekJYU2o6ZWZnaw==';

export type AutologinQuery = {
  uuid: string;
  requestDate: string;
  sessionToken: string;
};

export interface ILoginParams {
  email: string;
  password: string;
  model: string;
  appVersion: string;
  deviceToken: string;
  platform: string;
  deviceUUID: string;
  requestDate: string;
  manufacturer: string;
  osVersion: string;
}

const auth = {
  login({
    email,
    password,
    model,
    appVersion,
    deviceToken,
    platform,
    deviceUUID,
    requestDate,
    manufacturer,
    osVersion,
  }: ILoginParams) {
    return api.post('/login', {
      email,
      password,
      model,
      appVersion,
      deviceToken,
      platform,
      deviceUUID,
      requestDate,
      manufacturer,
      osVersion,
    });
  },
  resetPassword({ email, token }: { email: string; token: string }) {
    return api.post('/resetPassword', { email, token });
  },

  // "Auto-login" is a way to refresh the session token. Calling it will expire any
  // existing session tokens. This is used for the "Remember Me" feature.
  autoLogin(data: AutologinQuery, signal?: AbortSignal) {
    return api.post('/autologin', data, { signal });
  },

  // Mobile user automatic login, used when displaying the web app inside a WebView on mobile.
  // In this case, we get a JWT in the query string, which we pass to this endpoint
  // to get the session token.
  tokenAuthenticate(token: string) {
    return api.get('/damage-protection/authenticate', {
      // TODO: rename endpoint
      headers: {
        'gfh-auth-token': APP_TOKEN,
        token,
      },
    });
  },
  // This endpoint is also used for automatic login. It gets the full user data.
  tokenCurrentUser(token: string) {
    return api.get('/damage-protection/current-user', {
      // TODO: rename endpoint
      headers: {
        'gfh-auth-token': APP_TOKEN,
        token,
      },
    });
  },
  async zendeskSso() {
    return proxyAPI.get('/gfh-zendesk-auth/token/help-center');
  },
  async zendeskWidgetToken() {
    const { data } = await proxyAPI.get('/gfh-zendesk-auth/token/web-app');
    return data;
  },
  googleSSO(data: { googleIdToken: string; isSignIn: boolean }) {
    return api.post('/v3/google-sso', data);
  },
};

export default auth;
